import React from "react";

// Assets
import CollaseibleFQA from "./collaseibleFQA";
const RoundFAQPage = ({faqList}) => {
	return (
		<>
		<div className="faq-tab">
			<div className="faq-list">

				{faqList && faqList.length > 0 && faqList.map((list)=>{
					return <CollaseibleFQA question={list.question} answer={list.answer} />
				})}
			</div>
			</div>
		</>
	);
};

export default RoundFAQPage;
